// extracted by mini-css-extract-plugin
export default {"overlay":"kC-z","bodyOpen":"lC-z","content":"mC-z","header":"nC-z","close":"oC-z","closeNoHeading":"pC-z"};